import { Form, Modal, Table } from "react-bootstrap";
import { apiPost, apiPut } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { useEffect, useState } from "react";
const UpdateSelection = ({ onClose, object, getMatchData }) => {
  const [data, setData] = useState(object?.runners);
  const updateMatchMatchOddsSports = async (sportsListingUpdateId) => {
    try {
      const { status, data: response_users } = await apiPost(
        apiPath.updateBlockListinStatus,
        sportsListingUpdateId
      );
      if (status === 200) {
        if (response_users.success) {
          getMatchData();
          onClose();
        } else {
        }
      }
    } catch (err) {}
  };

  useEffect(() => {
    if (object?.backLay?.length > 0) {
      setData(
        object?.runners?.map((res) => {
          let obj = object?.backLay?.find((item) => {
            return item?.SelectionId == res?.SelectionId;
          });
          if (obj?.SelectionId == res?.SelectionId) {
            return {
              ...res,
              lockBackBets: obj?.lockBackBets,
              lockLayBets: obj?.lockLayBets,
            };
          } else {
            return res;
          }
        })
      );
    }
  }, [object]);
  return (
    <Modal size="2xl" show={true} onHide={onClose}>
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="modal-title-status">
          {object?.eventName} - {object?.market}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="responsive">
          <Table>
            <thead>
              <tr>
                <th scope="col">Runner Name</th>
                <th scope="col">Lay OFF</th> <th scope="col">Back OFF</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.map((res, index) => {
                  return (
                    <>
                      <tr key={index}>
                        <td>{res?.RunnerName}</td>
                        <td>
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            checked={res?.lockLayBets}
                            onClick={function (e) {
                              updateMatchMatchOddsSports({
                                eventId: object?.eventId,
                                backLay: data?.map((item) => {
                                  if (res?.SelectionId == item?.SelectionId) {
                                    return {
                                      ...item,
                                      lockLayBets: !res?.lockLayBets,
                                    };
                                  } else {
                                    return item;
                                  }
                                }),
                              });
                            }}
                          />
                        </td>
                        <td>
                          <Form.Check
                            type="switch"
                            id="custom-switch"
                            checked={res?.lockBackBets}
                            onClick={(e) => {
                              updateMatchMatchOddsSports({
                                eventId: object?.eventId,
                                backLay: data?.map((item) => {
                                  if (res?.SelectionId == item?.SelectionId) {
                                    return {
                                      ...item,
                                      lockBackBets: !res?.lockBackBets,
                                    };
                                  } else {
                                    return item;
                                  }
                                }),
                              });
                            }}
                          />
                        </td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </Table>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default UpdateSelection;
